'use client'

import { useState } from 'react'

export type MiniDashboardPage = 'prompts' | 'competitors' | 'plan' | 'sources' | 'visibility'

export interface MiniDashboardState {
  activePage: MiniDashboardPage
  setActivePage: (page: MiniDashboardPage) => void
  expandedRowId: string | null
  setExpandedRowId: (id: string | null) => void
  selectedCompetitorId: string | null
  setSelectedCompetitorId: (id: string | null) => void
}

export function useMiniDashboardState(): MiniDashboardState {
  const [activePage, setActivePage] = useState<MiniDashboardPage>('prompts')
  const [expandedRowId, setExpandedRowId] = useState<string | null>(null)
  const [selectedCompetitorId, setSelectedCompetitorId] = useState<string | null>(null)

  return {
    activePage,
    setActivePage,
    expandedRowId,
    setExpandedRowId,
    selectedCompetitorId,
    setSelectedCompetitorId,
  }
}
